////////////////////////////////////////////////Slide
if (!customElements.get('dl-js-slide')) {
  class DL_Slide extends HTMLElement {
    constructor() {
      super();
      this.load = false;
      this.flg = null;
      this.init();
      this.makeCtrl();
      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);
      window.addEventListener('resize', this.onResize.bind(this));
      this.onScroll();
      this.update();
    }

    init() {
      if (!this.load) {
        this.li = this.querySelectorAll(".dl-js-slide__li");
        this.num = this.li.length;
        this.idx = 0;
        this.timer = null;
        this.load = true;
        if (this.getAttribute("data-interval")) {
          this.interval = this.getAttribute("data-interval");
        } else {
          this.interval = 6000;
        }
      }
      this.borderLine = window.innerHeight;
      this.top = DL_offsetTop(this);
      this.height = this.offsetHeight;

    }

    update() {
      const slide = this;
      DL_removeClass(slide.li, "is-active");
      DL_addClass(slide.li[slide.idx], "is-active");

      if (slide.dotsFlg) {
        DL_removeClass(slide.dots, "is-active");
        DL_addClass(slide.dots[slide.idx], "is-active");
      }
      if ( !slide.timer ) {
        slide.timer = setTimeout(function() {
          clearTimeout(slide.timer);
          slide.timer = null;

          slide.moveNext()
        }, slide.interval);
      }
    }

    moveNext() {
      if (this.idx < this.num - 1) {
        this.idx++;
      } else {
        this.idx = 0;
      }
      this.update()
    }

    movePrev() {
      if (this.idx > 0) {
        this.idx--;
      } else {
        this.idx = this.num - 1;
      }
      this.update()
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const _flg = this.flg;
      if (scrollTop + this.borderLine >= this.top) {
        if (scrollTop >= this.top + this.height) {
          this.flg = false;
        } else {
          this.flg = true;
        }
      } else {
        this.flg = false;
      }
      if (_flg != this.flg) {
        if (this.flg) {
          this.update()
          DL_addClass(this, "is-active");
        } else {
          clearTimeout(this.timer);
          this.timer = null;
          DL_removeClass(this, "is-active");
        }
      }
    }
    onResize() {
      this.init();
      
    }

    makeCtrl() {
      if(this.getAttribute("data-dots") && JSON.parse(this.getAttribute("data-dots"))){
        this.dotsFlg = true;
      } else {
        this.dotsFlg = false;
      }
      if(this.getAttribute("data-arrow") && JSON.parse(this.getAttribute("data-arrow"))){
        this.arrowFlg = true;
      } else {
        this.arrowFlg = false;
      }

      if (this.dotsFlg || this.arrowFlg) {
        var html = document.createElement("div");
        DL_addClass(html, "dl-js-slide__ctrl");
        var inner = document.createElement("div");
        DL_addClass(inner, "dl-js-slide__ctrl__wrap");
        if (this.arrowFlg) {
          var arrow_prev = document.createElement("button");
          DL_addClass(arrow_prev, "dl-js-slide__arrow", "prev");
          arrow_prev.textContent = "PREV";
          inner.appendChild(arrow_prev);
        }

        if (JSON.parse(this.getAttribute("data-dots"))) {
          // this.dotsFlg = true;
          var ul = document.createElement("ul");
          DL_addClass(ul, "dl-js-slide__dots");
          for (let l = 0; l < this.num; l++) {
            var li = document.createElement("li");
            var button = document.createElement("button");
            button.textContent = l + 1;
            li.appendChild(button);
            ul.appendChild(li);
          }
          inner.appendChild(ul);
        } else {
          // this.dotsFlg = false;
        }
        if (this.arrowFlg) {
          var arrow_next = document.createElement("button");
          DL_addClass(arrow_next, ["dl-js-slide__arrow", "next"]);
          arrow_next.textContent = "NEXT";
          inner.appendChild(arrow_next);
        }

        html.appendChild(inner);
        this.appendChild(html);

        const slide = this;
        if (slide.querySelectorAll(".dl-js-slide__arrow")) {
          slide.arrow = slide.querySelectorAll(".dl-js-slide__arrow");
          for (var i = 0; i < slide.arrow.length; i++) {
            slide.arrow[i].addEventListener(
              "click",
              function() {
                clearTimeout(slide.timer);
                slide.timer = null;
                if (DL_hasClass(this, "next")) {
                  slide.moveNext()
                } else {
                  slide.movePrev()
                }
              },
              false
            );
          }
        }

        if (slide.querySelectorAll(".dl-js-slide__dots li")) {
          slide.dots = slide.querySelectorAll(".dl-js-slide__dots li");
          for (var i = 0; i < slide.dots.length; i++) {
            slide.dots[i].setAttribute("data-index", i);
            slide.dots[i].addEventListener(
              "click",
              function() {
                if (!DL_hasClass(this, "is-active")) {
                  clearTimeout(slide.timer);
                  slide.timer = null;
                  const dot_idx = this.getAttribute("data-index");
                  slide.idx = dot_idx;
                  slide.update()
                }
              },
              false
            );
          }
        }
      }
    }
  }
  customElements.define('dl-js-slide', DL_Slide);
}